import React, { useState } from "react";
import TagInputs from "../../inputs/TagInputs";
import toast from "react-hot-toast";
import { put } from "../../../utility/fetch";

const SettingDependant = ({ nextStep, data }) => {
    const [payload, setPayload] = useState({})
    const [groupLoading, setGroupLoading] = useState(false);

    const updateProfile = async () => {
        setGroupLoading(true);
        const response = await put(`/Patient/${data?.id}`, payload);
        if (response.statusCode === 200) {
            toast.success("You have successfully updated your profile");
        } else {
            toast.error("Error updating profile");
        }
        setGroupLoading(false);
    };
    return (
        <div className="card p-40">
            <div className="profile-header m-b-40 flex space-between">
                <div className="flex">
                    <img src={payload.pictureUrl || "user-avater.png"} alt="User" className="profile-pic" />
                    <div className="m-l-10">
                        <h3>{`${data?.fullName || ""}`}</h3>
                        <p>{data?.email}</p>
                    </div>
                </div>
                <button
                    disabled={groupLoading}
                    className="save-drafts col-3"
                    onClick={updateProfile}
                >
                    Save Changes
                </button>
            </div>

            <div className="flex space-between">
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="Gabriel Dickson Williams" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='female' />

                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="+23481 980 7650" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="gabriel@example.com" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="01/01/1989" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='female' />
                    </div>
                </form>
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="Gabriel Dickson Williams" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='female' />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="+23481 980 7650" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="gabriel@example.com" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="01/01/1989" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='Nigerian' />
                    </div>
                </form>
            </div>
            <h2 className="m-b-20 m-t-20">Means of Identification</h2>
            <div className="flex space-between">
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="Gabriel Dickson Williams" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='female' />

                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="+23481 980 7650" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="gabriel@example.com" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="01/01/1989" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='female' />
                    </div>
                </form>
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="Gabriel Dickson Williams" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='female' />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="+23481 980 7650" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="gabriel@example.com" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' type="text" value="01/01/1989" readOnly />
                    </div>
                    <div className="form-group">
                        <TagInputs label='Full Name' value='Nigerian' />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default SettingDependant;